import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

const BillingCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[500px]">
      <Card className="w-full max-w-md">
        <CardContent className="pt-10 pb-8 text-center space-y-6">
          <div className="flex justify-center">
            <div className="flex items-center justify-center w-20 h-20 rounded-full bg-warning/10">
              <AlertCircle className="w-10 h-10 text-warning" />
            </div>
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">Proceso cancelado</h1>
            <p className="text-muted-foreground">
              No se realizó ningún cobro. Podés intentarlo nuevamente cuando quieras.
            </p>
          </div>

          <Button onClick={() => navigate('/billing')}>
            Volver a Suscripción
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingCancel;
